<template>
  <div>
    <a-card :bordered="false" v-if="!productDetailsShow">
      <div class="bonus-header">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24" type="flex" align="top" class="select-container">
            <a-col :md="6" :sm="12">
              <a-form-item label="分组名称:">
                <a-input
                  placeholder="请输入分组名称"
                  v-model="groupName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button @click="addGroup" type="primary" icon="plus"
          >新增分组</a-button
        >

        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <div class="table">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          bordered
          :columns="columns"
          :data-source="prouuctArr"
          rowKey="id"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">产品</a>

            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
              <a-menu slot="overlay">
                <a-menu-item
                  ><a @click="showFieldModal(record)">表头字段</a></a-menu-item
                >
                <a-menu-item
                  ><a @click="confirmCopyProduct(record)">编辑</a></a-menu-item
                >

                <a-menu-item>
                  <a @click="delProductGroup(record.id)">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
      <!-- 新增产品 -->
      <add-product
        ref="modalAdd"
        @initProductList="initProductList"
      ></add-product>
      <!-- 表头字段 -->
      <header-field
        ref="modalField"
        @initProductList="initProductList"
      ></header-field>
    </a-card>
    <product-Detail
      v-if="productDetailsShow"
      ref="modalProduct"
      @close="close"
    ></product-Detail>
  </div>
</template>
<script>
import { getGroupList, deleteGroup } from '@/api/product';
import headerField from './modules/headerField.vue';
import addProduct from './modules/addProduct.vue';
import productDetail from './modules/productDetail.vue';

const columns = [
  {
    title: '分组名称',
    align: 'center',
    dataIndex: 'groupName',
    scopedSlots: { customRender: 'groupName' },
    width: 300
  },
  // { title: '产品规模', align: 'center', dataIndex: 'productScale', width: 100 },
  {
    title: '表头展示信息',
    align: 'center',
    dataIndex: 'headShow'
  },

  {
    title: '创建时间',
    align: 'center',
    dataIndex: 'createTime',
    sorter: (a, b) => {
      return a.createTime > b.createTime ? 1 : -1;
    }
  },

  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: '150px',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  data() {
    return {
      productDetailsShow: false,
      groupName: '', //分组名称
      columns,
      expand: false, //搜索展开收起
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      prouuctArr: [],
      selectedRowKeys: []
    };
  },
  components: {
    headerField,
    addProduct,
    productDetail
  },
  created() {
    this.initProductList();
  },
  methods: {
    //查看产品
    handleDetail(records) {
      this.productDetailsShow = true;
      this.$nextTick(() => {
        this.$refs.modalProduct.getFundInfo(records);
      });
    },
    //返回 关闭产品查看
    close() {
      this.productDetailsShow = false;
    },
    //批量操作选择的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(selectedRowKeys);
    },
    //
    batchDel() {
      this.delProductGroup(this.selectedRowKeys);
    },
    //删除/批量删除
    delProductGroup(ids) {
      let idsArr = [];
      if (Array.isArray(ids)) {
        idsArr = ids;
      } else {
        idsArr.push(ids);
      }
      let params = {
        grouopIds: idsArr
      };
      deleteGroup(params).then(res => {
        if (res.success) {
          this.$message.success('操作成功');
          this.initProductList();
        } else {
          this.$$message.error(res.meaasge);
        }
      });
    },
    //编辑
    confirmCopyProduct(records) {
      this.$refs.modalAdd.handleAddVisible(records);
    },
    //搜索
    searchQuery(e) {
      e.preventDefault();
      this.initProductList(1);
    },

    //重置
    searchReset() {
      this.groupName = '';
      this.initProductList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    //table数据
    initProductList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        groupName: this.groupName,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      };
      that.loading = true;
      getGroupList(params).then(res => {
        that.loading = false;
        if (res.success) {
          that.prouuctArr =
            res.result && res.result.records ? res.result.records : [];

          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    //展示表头数据
    showFieldModal(record) {
      this.$refs.modalField.handleFieldVisible(record);
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(selectionRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initProductList();
    },

    //新增分组
    addGroup() {
      this.$refs.modalAdd.handleAddVisible();
    }
  }
};
</script>
<style scoped lang="less">
.table-operator {
  margin: 20px 0;
}
</style>
